
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 39 39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-cogicon__cog",attrs:{"fill":"#D85427","d":"M16.844.15S18.131 0 19.417 0s2.572.15 2.572.15l1.09 4.664c1.453.363 2.822.937 4.073 1.688l4.07-2.528s1.015.804 1.925 1.713a25 25 0 0 1 1.712 1.926l-2.528 4.068a15 15 0 0 1 1.689 4.074l4.663 1.09s.15 1.286.15 2.572-.15 2.572-.15 2.572l-4.663 1.09a15 15 0 0 1-1.689 4.073l2.528 4.07s-.803 1.015-1.712 1.925c-.91.91-1.926 1.712-1.926 1.712l-4.069-2.528a15 15 0 0 1-4.073 1.689l-1.09 4.663s-1.286.15-2.572.15-2.573-.15-2.573-.15l-1.09-4.663a15 15 0 0 1-4.072-1.689l-4.07 2.528s-1.015-.803-1.925-1.712c-.91-.91-1.713-1.926-1.713-1.926l2.528-4.069a15 15 0 0 1-1.688-4.073L.15 21.989S0 20.703 0 19.417s.15-2.573.15-2.573l4.664-1.09a15 15 0 0 1 1.688-4.072l-2.528-4.07s.804-1.015 1.713-1.925c.91-.91 1.926-1.713 1.926-1.713l4.068 2.528a15 15 0 0 1 4.074-1.688z"}}),_c('path',{staticClass:"i-cogicon__c",attrs:{"fill":"#fff","d":"M23.943 21.164a5.04 5.04 0 0 1-1.753 2.072 5.2 5.2 0 0 1-2.779.862 5.1 5.1 0 0 1-1.942-.377 5.27 5.27 0 0 1-2.211-1.83 5.2 5.2 0 0 1-.864-2.774c0-.7.135-1.346.378-1.938a4.95 4.95 0 0 1 1.807-2.18 5.2 5.2 0 0 1 2.779-.862c.7 0 1.348.134 1.942.377a4.95 4.95 0 0 1 2.185 1.803c.134.216.27.431.377.673l5.53-1.426c-.081-.216-.162-.404-.243-.62a10.74 10.74 0 0 0-3.857-4.684 10.54 10.54 0 0 0-5.961-1.831c-1.403.054-2.806.35-4.073.888a10.75 10.75 0 0 0-4.694 3.85 10.5 10.5 0 0 0-1.834 5.95c0 1.454.297 2.854.836 4.146a10.74 10.74 0 0 0 3.857 4.685c1.7 1.158 3.75 1.83 5.961 1.83 1.457 0 2.86-.295 4.154-.834a10.76 10.76 0 0 0 4.694-3.85c.512-.754.917-1.561 1.24-2.45z"}})])
          )
        }
      }
    